<template>
  <div :id="id" :class="wrapperClasses">
    <div class="container mx-auto flex max-w-screen-xl flex-col">
      <VcTypography v-if="title" tag="h2" variant="h1" class="mb-6 text-center">
        {{ title }}
      </VcTypography>

      <div v-if="subtitle" class="text-center text-base">
        {{ subtitle }}
      </div>
      <div class="items-top mt-16 grid grid-cols-1 gap-x-20 gap-y-10 px-8 lg:grid-cols-3 lg:px-0">
        <div v-for="(item, index) in columns" :key="index" class="text-center">
          <div class="mb-9 w-auto">
            <VcImage v-if="item.icon" :src="item.icon" class="feature-image mx-auto h-24" lazy />
            <VcImage
              v-else-if="item.image"
              :src="item.image"
              class="min-h-60 mx-auto h-full w-full rounded-2xl object-cover lg:max-h-60"
              lazy
            />
          </div>
          <div class="mb-3 text-[22px] font-bold">
            {{ item.title }}
          </div>
          <div class="text-sm">
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

type ColumnsType = {
  title: string;
  text: string;
  image: string;
  icon: string;
};

interface IProps {
  id: string;
  background?: string;
  textColor?: string;
  bottomMargin?: string;
  verticalPadding?: string;
  title?: string;
  subtitle?: string;
  columns?: Array<ColumnsType>;
}

const props = defineProps<IProps>();

const wrapperClasses = computed(() => {
  return [
    props.background ? props.background : "",
    props.textColor ? props.textColor : "text-[color:var(--color-body-text)",
    props.bottomMargin ? props.bottomMargin : "my-0",
    props.verticalPadding ? props.verticalPadding : "py-10 lg:py-20",
  ];
});
</script>

<style scoped lang="scss">
.vc-typography--variant--h1 {
  @apply normal-case;
}
.feature-image {
  background: var(--color-primary);
  border-radius: 50%;
  padding: 15px;
  color: #fff;
}
</style>
